module.exports = __webpack_public_path__ + "static/media/tenancy-mobile.614c24de.png";